<template>
  <v-col class="tabs-container">
    <v-container grid-list-xs fluid class="ml-sm-3 pt-0">
      <v-row no-gutters class="tes-card tes-card_orange-border">
        <v-col cols="12">
          <div class="bg-main-orange px-5 py-4 text-uppercase text-center">
            <span class="fs-20 white--text" 
                :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">{{$t('pages.personalInformation.notification')}}</span>
          </div>
          <div class="px-3 py-7">
            <p class="fs-14"
              :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">{{$t('pages.personalInformation.sendEmail')}}</p>
       <!--     <v-checkbox
              v-model="userSettings.receiveMonthlyMaillingReceiptsByEmail"
              color="#39b54a"
              hide-details
              :disabled="true"
              @change="updateReceiveSettings"
            >
              <template v-slot:label>
                <div class="helvetica-roman">Единый платежный документ</div>
              </template>
            </v-checkbox> -->
            <v-checkbox
              v-model="userSettings.receiveAlertsByEmail"
              color="#39b54a"
              class="mt-2"
              hide-details
              :disabled="loading"
              @change="updateReceiveSettings"
            >
              <template v-slot:label>
                <div :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">{{$t('pages.personalInformation.statuses')}}</div>
              </template>
            </v-checkbox>
            <v-checkbox
              label="Информационные рассылки"
              v-model="userSettings.receiveNewsByEmail"
              color="#39b54a"
              class="mt-2"
              hide-details
              :disabled="loading"
              @change="updateReceiveSettings"
            >
              <template v-slot:label>
                <div :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">{{$t('pages.personalInformation.news')}}</div>
              </template>
            </v-checkbox>
         <!--   <p class="mt-5 mb-4 helvetica-medium fs-14">Отправлять по SMS</p> -->
            <!--<v-checkbox
              v-model="userSettings.receiveAlertsBySms"
              color="#39b54a"
              hide-details
              :disabled="loading"
              @change="updateReceiveSettings"
            >
              <template v-slot:label>
                <div class="helvetica-roman">Статусы обращений</div>
              </template>
            </v-checkbox>-->
        <!--    <v-checkbox
              class="mt-2 mb-7"
              v-model="userSettings.receiveAlertsBySms"
              color="#39b54a"
              hide-details
              :disabled="loading"
              @change="updateReceiveSettings"
            >
              <template v-slot:label>
                <div class="helvetica-roman">Уведомления об отключениях электроэнергии</div>
              </template>
            </v-checkbox> -->
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  name: "SettingsNotifications",
  computed: {
    userSettings() {
      return { ...this.$store.getters["account/userSettings"] };
    },
    ...mapGetters("locale",["currentLocale"]),
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    updateReceiveSettings() {
      this.loading = true;
      this.$store
        .dispatch("account/updateReceiveSettings", this.userSettings)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss">
</style>
